import eventBus from '~/plugins/event-bus';

const FAVORITE_PRODUCT_IDS = 'favorites_products_novaporta';

const callFavoritesUpdate = items => {
    eventBus.$emit('update-favorites', items);
};

export const getFavorites = () => {
    if (!process.client) {
        return [];
    }
    const items = localStorage?.getItem(FAVORITE_PRODUCT_IDS);
    return items ? JSON.parse(items) : [];
};

export const cleanFavorites = () => {
    if (!process.client) {
        return;
    }
    localStorage.setItem(FAVORITE_PRODUCT_IDS, JSON.stringify([]));
};

export const setFavorite = product => {
    const cleanProductId = product?.id || product?.productId;
    const productId = Number(cleanProductId);
    const items = getFavorites();

    if (isProductInFavorites(productId)) {
        let index = items.indexOf(productId);
        if (index !== -1) {
            items.splice(index, 1);
            if (process.client) {
                localStorage.setItem(FAVORITE_PRODUCT_IDS, JSON.stringify(items));
            }
        }
        callFavoritesUpdate(items);
    } else {
        items.push(productId);

        if (process.client) {
            const contextStore = window?.$nuxt?.$store;
            const settings = contextStore?.state?.global?.globalSettings;
            const currency = settings?.project_currency?.toUpperCase() || '';

            const sendData = {
                currency: currency,
                value: Number(product?.price),
                items: [
                    {
                        item_id: product?.productId,
                        item_name: product?.title,
                        discount: product?.discount || 0,
                        item_brand: product?.brand?.name || '',
                        item_category: product?.category?.[0]?.subcategoryTitle || '',
                        item_category2: product?.category?.[1]?.subcategoryTitle || '',
                        item_category3: product?.category?.[2]?.subcategoryTitle || '',
                        item_category4: product?.category?.[3]?.subcategoryTitle || '',
                        item_category5: product?.category?.[4]?.subcategoryTitle || '',
                        price: product?.discount ? Number(product?.old_price) : Number(product?.price),
                        quantity: 1
                    }
                ]
            };
            contextStore?.dispatch('google_events/sendItemWishlist', sendData);
        }

        if (process.client) {
            localStorage.setItem(FAVORITE_PRODUCT_IDS, JSON.stringify(items));
        }
        callFavoritesUpdate(items);
    }
};

export const isProductInFavorites = productId => {
    return getFavorites().includes(productId);
};
